export default __webpack_public_path__ + "static/premagic-feed-test-f3586eccb9e430420408006dd4f18dc9.jpg";